import { type ComponentProps } from 'react';

import { cn } from '../cn';
import { ButtonPropsSizeType } from '../common.type';

type ButtonIconProps = ComponentProps<'div'> & {
  size?: ButtonPropsSizeType;
};

function ButtonIcon({ size, className, children, style, ref, onClick }: ButtonIconProps) {
  return (
    <span
      ref={ref}
      className={cn(
        'flex aspect-square h-full shrink-0 items-center justify-center [&>*]:h-full [&>*]:w-auto',
        {
          'p-2.5': size == 'md',
          'p-2': size == null,
          'p-1.5': size == 'sm',
          'p-1': size == 'xs',
        },
        className,
      )}
      style={style}
      onClick={onClick}>
      {children}
    </span>
  );
}

export default ButtonIcon;
